import { EmployeeRequestStatus } from '@iota/inh-core-v1-management-client';

export const EmployeeRequestStatusLabels: Record<EmployeeRequestStatus, string> = {
    // Explicit id: the plain source "New" resolves to a differently translated unit.
    [EmployeeRequestStatus.NEW]: $localize`:@@newSingular:New`,
    [EmployeeRequestStatus.CHECKING]: $localize`Checking`,
    [EmployeeRequestStatus.APPROVED]: $localize`Approved`,
    [EmployeeRequestStatus.TRANSFERRED]: $localize`Forwarded`,
    [EmployeeRequestStatus.COMPLETED]: $localize`Completed`,
    [EmployeeRequestStatus.REJECTED]: $localize`Rejected`,
    [EmployeeRequestStatus.DISCARDED]: $localize`Discarded`,
    [EmployeeRequestStatus.UNKNOWN]: $localize`Unknown`
};

export const EmployeeRequestStatusToThemeColor: Record<EmployeeRequestStatus, string> = {
    [EmployeeRequestStatus.NEW]: 'bg-iota-draft text-gray-500',
    [EmployeeRequestStatus.CHECKING]: 'bg-iota-requested text-yellow-700',
    [EmployeeRequestStatus.APPROVED]: 'bg-iota-inh-green',
    [EmployeeRequestStatus.COMPLETED]: 'bg-iota-inh-green',
    [EmployeeRequestStatus.DISCARDED]: 'bg-iota-inh-green',
    [EmployeeRequestStatus.REJECTED]: 'bg-iota-rejected text-red-700',
    [EmployeeRequestStatus.TRANSFERRED]: 'bg-iota-warning',
    [EmployeeRequestStatus.UNKNOWN]: 'bg-iota-warning'
};

export function submissionStatusBadgeClass(status: EmployeeRequestStatus | undefined, isPreventionCourse: boolean): string {
    if (!status) {
        return 'bg-iota-warning';
    }
    if (status === EmployeeRequestStatus.TRANSFERRED && isPreventionCourse) {
        return 'bg-iota-inh-green';
    }
    return EmployeeRequestStatusToThemeColor[status];
}
